export default "__VITE_ASSET__BDKEUSwG__"